import React, { useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { SessionContext } from "../context/sessionContext";
import { useUser } from "../context/UserContext";
import SettingsModal from "./SettingsModal";

export default function SidebarNavigation({ users = [], bucketUrl = "" }) {
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const { userData, profilePicUrl, isAdmin, roleName, getInitials } = useUser();
  const { logout, session } = useContext(SessionContext);
  const navigate = useNavigate();

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      await logout();
      navigate("/log-in", { replace: true });
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      setIsLoggingOut(false);
      setShowProfileDropdown(false);
    }
  };

  const handleProfileClick = (e) => {
    e.stopPropagation();
    setShowProfileDropdown(!showProfileDropdown);
  };

  useEffect(() => {
    const closeDropdown = () => setShowProfileDropdown(false);
    if (showProfileDropdown) {
      document.addEventListener("click", closeDropdown);
      return () => document.removeEventListener("click", closeDropdown);
    }
  }, [showProfileDropdown]);

  const username = userData?.username || "Loading...";
  const initials = getInitials();

  if (isAdmin) {
    return null;
  }

  return (
    <>
      <div className="sidebar-container">
        <div className="logo">
          <Link to="/">
            <img
              src={"/json-media/img/logo.svg"}
              alt="GI"
              width={40}
              className="logo-img"
            />
          </Link>
        </div>

        <div className="menulist">
          {roleName?.toLowerCase() !== "collaborator" && (
            <Link to="/create-survey">
              <img
                src={"/json-media/icons/add-icons.svg"}
                alt="create survey"
              />
            </Link>
          )}

          <div className="userLogin">
            <div
              className={`sidebar-user-avatar ${profilePicUrl ? "has-photo" : "has-initials"}`}
              onClick={handleProfileClick}
            >
              {profilePicUrl ? (
                <img src={profilePicUrl} alt="profile" className="avatar-img" />
              ) : (
                initials
              )}
            </div>

            {showProfileDropdown && (
              <div
                className="user-dropdown"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="dropdown-user-info">
                  <p>{username}</p>
                  <p>{roleName}</p>
                </div>
                <button
                  onClick={() => {
                    setShowSettingsModal(true);
                    setShowProfileDropdown(false);
                  }}
                  className="settings-btn"
                >
                  Settings
                </button>
                <button
                  onClick={handleLogout}
                  disabled={isLoggingOut}
                  className="logout-btn"
                >
                  {isLoggingOut ? "Logging out..." : "Logout"}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {showSettingsModal && (
        <SettingsModal
          isOpen={showSettingsModal}
          onClose={() => setShowSettingsModal(false)}
          onLogout={handleLogout}
        />
      )}
    </>
  );
}
